// @flow
// styles
import './GoBackButton.css';
// Hooks
import { useHistory } from 'react-router-dom';
// Assets
import arrowLeft from '../images/arrowLeft.svg';

type Props = {
  showLabel?: boolean,
  className?: string,
};

const GoBackButton = ({ showLabel = false, className = '' }: Props) => {
  const history = useHistory();

  const onClickGoBack = () => {
    if (history.location.key) {
      history.goBack();
    } else {
      history.push('/');
    }
  };

  return (
    <button
      type="button"
      className={`go-back-button ${
        showLabel ? 'go-back-button--with-label' : ''
      } ${className}`}
      onClick={onClickGoBack}
      aria-label="Voltar"
    >
      <img src={arrowLeft} alt="" />
      {showLabel && 'Voltar'}
    </button>
  );
};

export default GoBackButton;
